import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { paymentActions } from "../slices/payment";
import { getErrorMessage } from "../../utils/errorUtils";
import { DateRangePaginationQueryDto } from "../../shared/dtos/common/DateRangePaginationQueryDto";
import { PaymentSummaryDto } from "../../shared/dtos/payment/PaymentSummaryDto";
import { StkPushRequestDto } from "../../shared/dtos/payment/StkPushRequestDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getPayments =
  (params?: DateRangePaginationQueryDto) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(paymentActions.setLoading());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<PaymentSummaryDto>>
      >("/payments", {
        headers: { requiresAuth: true },
        params,
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(paymentActions.setItems(data.data.content));
        dispatch(paymentActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(paymentActions.setError(getErrorMessage(error)));
    }
  };

export const sendStkPush =
  (payload: StkPushRequestDto) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(paymentActions.setLoadingStkPush());
    try {
      const { data } = await axiosInstance.post<ApiResponseDto<void>>(
        "/payments/stk-push",
        payload,
        {
          headers: { requiresAuth: true },
        },
      );
      if (data.status === ApiResponseStatus.SUCCESS) {
        dispatch(paymentActions.setStkPushSuccess());
        toast.success(data.message || "STK Push sent successfully!");
        dispatch(
          paymentActions.setServerStatus({
            operation: "stk.push",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(paymentActions.setErrorStkPush(message));
    }
  };
